import { transformTermCode } from "../Search/util";
import { FORM_TYPE } from "../util/constants"; 
import { synchronousOptions, dropdownSubtypes } from "../util/enums";
import { formatDate, convertFormStatus, getFormStatusLabel, transformReportStatus } from "../util/functions";

export function transformTasks(tasks = []) {
    return tasks.map(task => {
        task.candidacyTypeLabel = (synchronousOptions[dropdownSubtypes.candidacyType].find(o => o.value === task.candidacyType)?.title || null);
        task.creationTimeLabel = formatDate(task.creationTime);
        const formTypeLabel = FORM_TYPE[task.formType];
        task.formTypeLabel = formTypeLabel;
        let description = "";
        if(formTypeLabel) description += `${formTypeLabel}`;
        if(task?.studentName) description += (description.length > 0 ? ` for ${task.studentName}` : `${task.studentName}`);
        if(task?.studentid) description += (description.length > 0 ? ` - ${task.studentid}` : `${task.studentid}`);
        task.description = description;
        task.examDateLabel = (task?.examDate ? formatDate(task.examDate, "MMMM d, y") : "");
        let endOfSemesterOptionLabel;
        switch(task?.endOfSemesterOption) {
            case "Y":
                endOfSemesterOptionLabel = "Yes";
                break;
            case "N":
                endOfSemesterOptionLabel = "No";
                break;
            default:
                endOfSemesterOptionLabel = null;
                break;
        }
        task.endOfSemesterOptionLabel = endOfSemesterOptionLabel;
        task.status = convertFormStatus(task.status, task.substatus);
        task.statusLabel = getFormStatusLabel(task.status);
        task.csvStatusLabel = getFormStatusLabel(transformReportStatus(task.formType, task.status));
        task.termLabel = (task?.termCode ? transformTermCode(task.termCode) : null);
        return task;
    });
}